'use strict'

const nav =  {
    el: {
        html          : document.querySelector('html'),
        body          : document.body,
        voile         : document.querySelector('.voile'),
        navBtn        : document.querySelector('.header_toggle'),
        navWrap       : document.querySelector('.navMobile'),
        scroll        : 0
    },

    init: function(){
        nav.events();
    },

    events: function() {
        // click sur le menu burger sur mobile
        if(nav.el.navBtn) {
            nav.el.navBtn.addEventListener('click', function() {
                nav.toggleNav();
            });
        }
    },

    // ouverture et fermeture de la navigation mobile
    toggleNav: function() {
        let html = nav.el.html;
        let body = nav.el.body;
        let navWrap = nav.el.navWrap;
        let height = window.innerHeight;
        
        if (html.classList.contains('nav-open')) {
            html.classList.remove('nav-open');
            navWrap.style.height = '';
            setTimeout(() => {
                navWrap.style.display = 'none';
                html.style.height = '';
                body.style.height = '';
            }, 250);
        }
        else {
            navWrap.style.display = 'block';
            html.style.height = height + 'px';
            body.style.height = height + 'px';
            setTimeout(() => {
                html.classList.add('nav-open');
                navWrap.style.height = height + 'px';
            }, 50);
        }
    },

    setSticky: function() {
        // let breakpoint = 49;
        let breakpoint = document.querySelector('.header').offsetHeight + 50;
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if(document.querySelector('body'))
            st >= breakpoint ? document.querySelector('body').classList.add('sticky') : document.querySelector('body').classList.remove('sticky')
        
        nav.el.last = st; // For Mobile or negative scrolling
    },
}


export default nav;



// WEBPACK FOOTER //
// ./src/scripts/components/nav.js